import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

export interface PackageChangeDetail {
  type: 'total_discount' | 'partial_discount';
  productName: string;
  quantity: number;
  originalValue: number;
  newValue: number;
  discount: number;
  freeQuantity?: number;
  paidQuantity?: number;
  message: string;
}

@Component({
  selector: 'app-package-balance-changes-modal',
  templateUrl: './package-balance-changes-modal.component.html',
  styleUrls: ['./package-balance-changes-modal.component.scss']
})
export class PackageBalanceChangesModalComponent implements OnInit {
  packageChangesDetails: PackageChangeDetail[] = [];

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {}

  ngOnInit(): void {
    this.packageChangesDetails = this.config.data?.packageChangesDetails || [];
  }

  closeModal(): void {
    this.ref.close();
  }

  getTotalDiscount(): number {
    return this.packageChangesDetails.reduce((total, change) => total + change.discount, 0);
  }
}
